import { render, staticRenderFns } from "./vipmember.vue?vue&type=template&id=39836938&"
import script from "./vipmember.vue?vue&type=script&lang=js&"
export * from "./vipmember.vue?vue&type=script&lang=js&"
import style0 from "./vipmember.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports